module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-layout', [_c('v-flex', {
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0"
    },
    attrs: {
      "xs3": ""
    }
  }, [_c('img', {
    staticClass: "v-responsive",
    attrs: {
      "src": _vm.user.avatar_url + '&s=200'
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "mr-4": ""
    }
  }, [_c('div', {
    staticClass: "headline"
  }, [_c('strong', [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))])]), _vm._v("\n      " + _vm._s(_vm.user.email)), _c('br'), _vm._v("\n      " + _vm._s(_vm.user.company_name)), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n      Last Login: " + _vm._s(_vm._f("moment")(_vm.user.login_at, 'MM/DD/YYYY [at] h:mm A [PT]z')) + "."), _c('br'), _vm._v(" "), (_vm.user.last_ordered_at) ? [_vm._v("\n        Last Order: " + _vm._s(_vm._f("moment")(_vm.user.last_ordered_at, 'MM/DD/YYYY [at] h:mm A [PT]z'))), _c('br')] : _vm._e(), _vm._v("\n      Total Order(s): " + _vm._s(_vm.user.number_of_orders)), _c('br')], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-198adf33","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/user-summary.vue
// module id = 676
// module chunks = 1